import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'my-portal-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss']
})
export class TagListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
